/**
 * 接口公共参数
*/
export const SqlBase = () => {
  return [
    {
      type: 'doubleSum',
      name: 'goodsWeight',
      fieldName: 'goodsWeight',
    },
    {
      type: 'doubleSum',
      name: 'goodsVolume',
      fieldName: 'goodsVolume',
    },
    {
      type: 'longSum',
      name: 'piece',
      fieldName: 'piece',
    },
    {
      type: 'longSum',
      name: 'ticket',
      fieldName: 'ticket',
    }
  ]
}

export const productItem = () =>  ['MINI电商小件', '精准零担', 'MINI电商大件', '定时达', '安心达', '普惠达'];
